// 知识库中文档类型（文档、知识本、表格、演示文稿、数据表）
export const DOC_TYPE = {
    DOCUMENT: 1, // 普通文档
    DIRECTORY: 2, // 知识本
    SHEET: 4, // 表格
    PPT: 6, // 演示文稿
    DATASHEET: 7, // 数据表
} as const;
export type IDocType = typeof DOC_TYPE[keyof typeof DOC_TYPE];

// 知识库中所有 type 映射（DOC_TYPE 是其子集）
export const KU_TYPE = {
    Doc: 1, // 普通文档
    Book: 2, // 知识本
    Repo: 3, // 知识库
    Sheet: 4, // 表格
    Group: 5, // 部门
    PPT: 6, // 演示文稿
    DataSheet: 7, // 数据表
};

export const DOC_TYPE_KEY = {
    DOCUMENT: 'doc', // 普通文档
    SHEET: 'sheet', // 表格
    PPT: 'ppt', // 演示文稿
    DATASHEET: 'datasheet', // 数据表
};

export const BOOK_TYPE = {
    NO_BOOK: 1, // 不在知识本内
    IS_BOOK: 2, // 知识本
    IN_BOOK: 3, // 在知识本内
};
export type BookType = typeof BOOK_TYPE[keyof typeof BOOK_TYPE];

export const BOOK_PUBLIC_TYPE = {
    isReaderPublic: 5,
    isMemberPublic: 6,
    isPrivate: 20,
};

// 演示模式缩放
export const DEMO_MODE_ZOOM = {
    default: 1.4, // 默认缩放数值
    reduce: 0.5, // 缩小最小值
    enlarge: 5, // 放大最大值
};

// 停服更新 tips 关闭状态缓存 key 值
export const SERVICE_UPDATE_STORAGE_KEY = 'serviceUpdateTipsExpiredTime';

// 演示模式分页
export const DEMO_MODE_PAGING = {
    wProportion: 16, // 内容展示区域比例宽
    hProportion: 9, // 内容展示区域比例高
    topProportion: 56,
    bottomProportion: 64,
    leftProportion: 80,
    pagingStart: 1, // 分页初始页码数
    storageName: 'storageDemoMode', // 存储文档的名字
};

// 演示模式中模式类型
export const DEMO_MODE_TYPE = {
    flow: 'flow',
    page: 'page',
    // outline: 'outline', // 大纲
};

/**
 * wps-sdk 的地址
 */
// eslint-disable-next-line max-len
export const WEB_OFFICE_URL = 'https://rte-fe-static.bj.bcebos.com/rte-online/rte-fe-static/rte-js/web-office-sdk-v1.1.19.umd.js';

// 数据表 token 缓存
export const DataSheetTokenStorageKey = 'datasheet_token';

// 数据表节点类型
export const DATASHEET_NODE_TYPE = {
    View: 'View', // 视图
    Dashboard: 'dashboard', // 仪表盘
    Form: 'form', // 问卷表单
};

// 文档页右侧边栏宽度，需要减去滚动条宽度 8 px
// 例如右侧边栏宽度为 388px，则这里宽度为 388 - 8 = 380px
export const RightSidebarWidth = 380;
